<template>
    <div class="update-main-con">
        <HeaderUpdateLabel @closeDialog="closeDialog" />
        <MainUpdateLabel />
        <FooterUpdateLabel @closeDialog="closeDialog" />
    </div>
</template>
<script setup lang="ts">
import { ModalNames } from '~/types/modals';

import FooterUpdateLabel from './FooterUpdateTag.vue';
import HeaderUpdateLabel from './HeaderUpdateTag.vue';
import MainUpdateLabel from './MainUpdateTag.vue';

const dialogRef =   getDialogRef(ModalNames.UPDATE_TAG);
const closeDialog = () => {
    dialogRef.value.close();
};
</script>
<style lang="scss" scoped>
.update-main-con {
     @apply sm:max-w-md sm:w-[440px] w-11/12 rounded-lg bg-white mx-auto h-auto overflow-y-auto;
}
</style>
